import { AlignItems, AlignSelf, JustifyContent, Color } from ".";
import { css, DefaultTheme } from "styled-components";

export type SetStyle = {
  theme?: DefaultTheme;
  _overflow?: "hidden" | "visible";
  _color?: string;
  _backgroundColor?: string;
  _border?: string;
  _boxShadow?: string;
  _borderRadius?: string;
  _textAlign?: "left" | "center" | "right";
  _display?: "flex" | "inline-flex" | "none";
  _flex?: number;
  _alignItems?: AlignItems;
  _justifyContent?: JustifyContent;
  _alignSelf?: AlignSelf;
  _flexDirection?: string;
  _height?: string | number;
  _width?: string;
  _maxWidth?: string;
  _flexWrap?: string;
  _borderColor?: string;
  _position?: string;
  _top?: string;
  _right?: string;
  _bottom?: string;
  _left?: string;
  _zIndex?: number;
};
export const setStyle = (props: SetStyle) => {
  const camelCase = /([a-z0-9]|(?=[A-Z]))([A-Z])/g;
  const stylesToString = Object.keys(props).reduce(
    (acc: string, rule: string) => {
      // @ts-ignore
      const cssValue = props[rule];

      if (rule.charAt(0) === "_" && cssValue) {
        acc += `${rule.replace("_", "").replace(camelCase, "$1-$2").toLowerCase()}: ${cssValue};`;
      }
      return acc;
    },
    "",
  );

  return css`
    ${stylesToString}
  `;
};

export type SetColor = {
  color?: Color;
  theme?: DefaultTheme;
};
export const setColor = (props: SetColor) =>
  props?.color && props.theme
    ? setStyle({ _color: props.theme[props.color] })
    : "";

export type SetBackgroundColor = {
  bg?: Color | string;
  theme?: DefaultTheme;
};
export const setBackgroundColor = (props: SetBackgroundColor) =>
  props?.bg && props.theme
    ? setStyle({ _backgroundColor: props.theme[props.bg] })
    : "";

export type SetBorder = {
  border?: boolean | string;
  theme?: DefaultTheme;
  borderColor?: Color;
  borderWidth?: string;
  borderStyle?: "solid" | "dashed" | "dotted";
};
export const setBorder = (props: SetBorder) => {
  const { border, theme, borderColor, borderStyle, borderWidth } = props;
  if (border === true) {
    return setStyle({ _border: `1px solid ${theme?.border}` });
  } else if (border) {
    return setStyle({ _border: border });
  } else if (borderColor && borderStyle && borderWidth) {
    return setStyle({
      _border: `${borderWidth} ${borderStyle} ${theme?.[borderColor]}`,
    });
  } else {
    return "";
  }
};

export type SetShadow = {
  theme?: DefaultTheme;
  shadow?: boolean | Color;
};
export const setShadow = (props: SetShadow) => {
  const { shadow, theme } = props;

  if (shadow === true) {
    return setStyle({ _boxShadow: theme?.shadow });
  } else if (shadow) {
    return setStyle({ _boxShadow: theme?.[shadow] });
  } else {
    return "";
  }
};

export type SetRadius = {
  theme?: DefaultTheme;
};
